<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="top-title-wrap">
          <div class="main-title">
            <span v-if="$route.params.id !== 'create'">{{ $t('Edit Changelog') }}</span>
            <span v-if="$route.params.id === 'create'">{{
                $t('Create new Changelog')
              }}</span>
          </div>
        </div>
        <box class="aud-box">
          <div class="row">
            <div class="col-md-7" :key="itemsKey">
              <div class="form-group full-width outer">
                <div class="row">
                  <div class="col-md-4">
                    <label class="group-title">{{ $t('Version') }} <i>*</i></label>
                    <dspInput
                      v-model="changeLog.version"
                      v-validate="'required'"
                      :errorsBag="errors"
                      name="version"
                      :placeholder="$t('Enter Version')"
                    >
                    </dspInput>
                  </div>
                </div>
              </div>
              <div class="form-group outer full-width">
                <div class="row">
                  <div class="col-md-4">
                    <label class="group-title">{{ $t('Date') }} <i>*</i></label>
                    <DateSelect :dateStart="changeLog.date.format('YYYY-MM-DD')"
                                :dateEnd="changeLog.date.format('YYYY-MM-DD')"
                                :errorsBag="errors"
                                :autoApply="false"
                                :showPresets="false"
                                :singleDatePicker="true"
                                @change="onPeriodChange($event)"
                                opens="left"
                                class="w-100"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group outer full-width">
                <div class="row">
                  <div class="col-md-4">
                    <label class="group-title">{{ $t('Title') }}</label>
                    <dspInput
                      v-model="changeLog.title"
                      v-validate="''"
                      :errorsBag="errors"
                      name="notes"
                      :placeholder="$t('Enter Title')">
                    </dspInput>
                  </div>
                </div>
              </div>
              <div class="changelog-item"
                   v-for="(item, index) of changeLog.items"
                   :key="index">
                <div class="item-title">Item{{ index + 1 }}</div>
                <div class="delete" v-if="changeLog.items.length>1">
                  <a href="#" @click.prevent="deleteItem(index)"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8.00008 9.41429L3.70718 13.7072L2.29297 12.293L6.58586 8.00008L2.29297 3.70718L3.70718 2.29297L8.00008 6.58586L12.293 2.29297L13.7072 3.70718L9.41429 8.00008L13.7072 12.293L12.293 13.7072L8.00008 9.41429Z"
                            fill="#C2CAD8"/>
                    </svg>
                  </a>
                </div>
                <div class="form-group">
                  <label class="group-title">{{ $t('Item Title') }}</label>
                  <dspInput
                    v-model="item.title"
                    v-validate="''"
                    :errorsBag="errors"
                    name="notes"
                    :placeholder="$t('Enter Item Title')">
                  </dspInput>
                </div>
                <div class="form-group">
                  <label class="group-title">{{ $t('Item Content') }}</label>
                  <b-form-textarea placeholder="Enter Item Content" v-model="item.text"

                                   rows="5"
                  ></b-form-textarea>
                  <div class="img-wrapper" v-if="item.file || item.previewUrl" :key="index">
                    <div class="img-preview">
                      <a class="delete-preview" href="#" @click.prevent="deletePreview(index)"
                      >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M8.00008 9.41429L3.70718 13.7072L2.29297 12.293L6.58586 8.00008L2.29297 3.70718L3.70718 2.29297L8.00008 6.58586L12.293 2.29297L13.7072 3.70718L9.41429 8.00008L13.7072 12.293L12.293 13.7072L8.00008 9.41429Z"
                                fill="#C2CAD8"/>
                        </svg>
                      </a>
                      <img v-if="item.preview" :src="item.preview" alt=""
                           :key="'preview-' + index" />
                      <img v-else-if="item.previewUrl" :src="item.previewUrl" alt=""
                           :key="'previewUrl-' + index" />
                    </div>
                  </div>
                  <div class="item-btn-wrap">
                    <label v-if="Boolean(item && item.file)===false &&  Boolean(item && item.previewUrl)===false"
                           class="input-wrapper">
                      <div class="icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M2.00065 9.33398C2.36884 9.33398 2.66732 9.63246 2.66732 10.0007V12.6673C2.66732 12.8441 2.73756 13.0137 2.86258 13.1387C2.9876 13.2637 3.15717 13.334 3.33398 13.334H12.6673C12.8441 13.334 13.0137 13.2637 13.1387 13.1387C13.2637 13.0137 13.334 12.8441 13.334 12.6673V10.0007C13.334 9.63246 13.6325 9.33398 14.0007 9.33398C14.3688 9.33398 14.6673 9.63246 14.6673 10.0007V12.6673C14.6673 13.1978 14.4566 13.7065 14.0815 14.0815C13.7065 14.4566 13.1978 14.6673 12.6673 14.6673H3.33398C2.80355 14.6673 2.29484 14.4566 1.91977 14.0815C1.5447 13.7065 1.33398 13.1978 1.33398 12.6673V10.0007C1.33398 9.63246 1.63246 9.33398 2.00065 9.33398Z"
                                fill="#637381"/>
                          <path fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.52925 1.52925C7.7896 1.2689 8.21171 1.2689 8.47206 1.52925L11.8054 4.86258C12.0657 5.12293 12.0657 5.54504 11.8054 5.80539C11.545 6.06574 11.1229 6.06574 10.8626 5.80539L8.00065 2.94346L5.13872 5.80539C4.87837 6.06574 4.45626 6.06574 4.19591 5.80539C3.93556 5.54504 3.93556 5.12293 4.19591 4.86258L7.52925 1.52925Z"
                                fill="#637381"/>
                          <path fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M8.00065 1.33398C8.36884 1.33398 8.66732 1.63246 8.66732 2.00065V10.0007C8.66732 10.3688 8.36884 10.6673 8.00065 10.6673C7.63246 10.6673 7.33398 10.3688 7.33398 10.0007V2.00065C7.33398 1.63246 7.63246 1.33398 8.00065 1.33398Z"
                                fill="#637381"/>
                        </svg>
                      </div>
                      <div class="btn-text">Upload File</div>
                      <input v-validate="{ image: true, ext: ['jpg','jpeg','png'],size:5000 }"

                             :data-vv-as="$t('Image')"
                             :errorsBag="errors"
                             @change="onImageInputChange($event, index)"
                             type="file"
                             ref="mediaImage"
                             name="mediaImage">
                    </label>
                  </div>
                </div>
              </div>
              <div class="add-item" @click="addItem">
                            <span class="icon">
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_12465_61556)">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6Z"
                                      fill="#740B99"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M6 3.5C6.27614 3.5 6.5 3.72386 6.5 4V8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8V4C5.5 3.72386 5.72386 3.5 6 3.5Z"
                                      fill="#740B99"/>
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M3.5 6C3.5 5.72386 3.72386 5.5 4 5.5H8C8.27614 5.5 8.5 5.72386 8.5 6C8.5 6.27614 8.27614 6.5 8 6.5H4C3.72386 6.5 3.5 6.27614 3.5 6Z"
                                      fill="#740B99"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_12465_61556">
                                <rect width="12" height="12" fill="white"/>
                                </clipPath>
                                </defs>
                              </svg>

                            </span>
                Add item
              </div>

            </div>
          </div>
          <div class="btn-wrap">
            <a @click="$router.go(-1)"
               class="button plain">{{ $t('Cancel') }}</a>
            <dspButton :disabled="saveBtnDisabled"
                       @click="createOrEdit"
                       class="primary">{{ $t('Save') }}
            </dspButton>
          </div>
        </box>
      </div>
    </div>
  </div>
</template>

<script>


import moment from "moment";
import DateSelect from "@/components/DatePicker/DateSelect.vue";

export default {
  name: 'changelogEdit',
  components: {
    DateSelect,
  },
  data: function () {
    return {
      itemsKey:0,
      preview: null,
      saveBtnDisabled: false,
      showPreviewForEdit: false,
      testPrefix: process.env.NODE_ENV === 'development' && process.env.VUE_APP_API_URL === 'http://dsp.test/api' ? 'http://dsp.test/storage/app/' : '',
      file: {},
      changeLog: {
        version: '0.0.1',
        date: moment(),
        title: '',
        items: [
          {
            title: '', text: '', file: null, preview: null, savedFileName: '', previewUrl: ''
          }
        ]
      }
    }
  },
  created() {
    if (this.$route.params.id !== 'create') {
      this.$axios.get('/admin/changeLog/' + this.$route.params.id).then(response => {
        let data = response.data;
        data['date'] = moment(data['date']);
        this.changeLog = data;
      });
    }
  },
  methods: {
    onImageInputChange(e, index) {
      const file = e.target.files[0];
      if (!file) return;

      const item = this.changeLog.items[index];
      if (item.preview && item.preview.startsWith("blob:")) {
        URL.revokeObjectURL(item.preview);
      }
      const previewUrl = URL.createObjectURL(file);

      item.file = file;
      item.preview = previewUrl;
      this.$set(this.changeLog.items, index, item);
      this.itemsKey++;
    },
     deletePreview(index) {
      const item = this.changeLog.items[index];
      // if (item.savedFileName) {
      //   try {
      //     await this.$axios.delete(`/admin/uploadImageChangelog/${item.savedFileName}`);
      //     this.$notify.info('File deleted from server');
      //   } catch (err) {
      //     this.$notify.info('Error while deleting from server');
      //   }
      // }
      if (this.$route.params.id !== 'create') {
        this.showPreviewForEdit = true;
      }
      if (item.preview) {
        if (item.preview.startsWith("blob:")) {
          URL.revokeObjectURL(item.preview);
        }

      }
      item.preview = null;
      item.file = null;
      item.savedFileName = null;
      item.previewUrl = null;
      this.itemsKey++;
    },
    async createOrEdit() {
      const valid = await this.$validator.validateAll();
      if (!valid) return false;

      for (let i = 0; i < this.changeLog.items.length; i++) {
        const item = this.changeLog.items[i];

        if (item.file) {
          const formData = new FormData();
          formData.append('mediaImage', item.file);

          try {
            const {data} = await this.$axios.post(
              '/admin/uploadImageChangelog',
              formData,
              {
                headers: {'Content-Type': 'multipart/form-data'}
              }
            );

            item.savedFileName = data.fileName;
            item.previewUrl = data.url;
            delete item.file;
          } catch (err) {
            this.$notify.info('Error Loading img');
          }
        }
      }

      const payload = {
        version: this.changeLog.version,
        date: this.changeLog.date.format('YYYY-MM-DD'),
        title: this.changeLog.title,
        items: this.changeLog.items.map(item => ({
          title: item.title,
          text: item.text,
          savedFileName: item.savedFileName,
          previewUrl: item.previewUrl,
        }))
      };

      let promise;
      if (this.$route.params.id === 'create') {
        promise = this.$axios.post('/admin/changeLog', payload);
      } else {
        promise = this.$axios.put('/admin/changeLog/' + this.$route.params.id, payload);
      }

      promise.then(() => {
        this.$notify.info('Saved!');
        this.$router.push({name: 'changelog'});
      });
    },
    onPeriodChange(event) {
      this.changeLog.date = moment(event.dateStart);
    },
    deleteItem(index) {

      this.$delete(this.changeLog.items, index);
    },
    addItem() {
      this.changeLog.items.push({
        title: '',
        text: '',
        preview: null,
        file: null,
        savedFileName: '',
      })
    }

  }

}
</script>

<style lang="scss" scoped>
.mt3 {
  margin-top: 8px !important;
}

::v-deep .mdrp-root {
  display: block;

  .mdrp__activator .activator-wrapper .text-field {
    width: 100%;
  }
}

.changelog-item {
  padding: 10px 20px;
  border: 1px solid #C2CAD8;
  border-radius: 5px;
  position: relative;
  margin-bottom: 20px;

  .img-wrapper {
    padding-top: 20px;

    .img-preview {
      width: 160px;
      height: 160px;
      position: relative;
      border: 1px dashed #DFE3E8;
      border-radius: 5px;
      overflow: hidden;

      .delete-preview {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 2;
      }

      img {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
  }

  .input-wrapper {
    width: 128px;
    height: 35px;
    border: 1px solid #C2CAD8;
    background: #fff;
    display: flex;
    font-size: 12px;
    align-items: center;
    cursor: pointer;
    border-radius: 5px;
    margin-top: 20px;

    input {
      width: 0;
      height: 0;
      position: absolute;
      opacity: 0;
      visibility: hidden;
    }

    .icon {
      margin-left: 10px;
      margin-right: 10px;
    }
  }

  textarea {
    &::placeholder {
      color: #C2CAD8 !important;
    }
  }

  .item-title {
    font-size: 14px;
    padding-bottom: 20px;
  }

  .delete {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 7px;
    right: 7px;

    a {
      width: 16px;
      height: 16px;

      svg {
        vertical-align: top;
      }
    }
  }

  .form-group {
    max-width: 100%;
  }

  .input-wrap {
    width: 100%;

    .input-text {
      width: 100%;
    }
  }
}

.add-item {
  font-size: 12px;
  cursor: pointer;

  .icon {
    margin-right: 4px;
  }
}
</style>

